import classNames from "classnames";
import noop from "lodash/noop";
import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import Checkbox from "@Components/atoms/Checkbox";
import { Price } from "@Types/api/price";
import "./style.scss";

interface Props {
  isSelected: boolean;
  onSelectChange: () => void;
  onToggleHover: () => void;
  upsell: {
    description: string;
    price: Price;
    title: string;
  };
}

const UpsellItem: FunctionComponent<Props> = ({
  isSelected,
  onSelectChange,
  onToggleHover,
  upsell,
}) => {
  const intl = useIntl();
  // todo: A modifier ? Ici on utilise le format habituel price.cents alors qu'on est pas en cents
  const priceFormated = intl.formatNumber(upsell.price.cents, {
    currency: upsell.price.currency,
    style: "currency",
  });

  return (
    <div
      className={classNames("UpsellItem", {
        "UpsellItem--selected": isSelected,
      })}
      onClick={onSelectChange}
      onMouseEnter={onToggleHover}
      onMouseLeave={onToggleHover}
    >
      <div className="UpsellItem-checkbox">
        <Checkbox checked={isSelected} onChange={noop} type="square" />
      </div>
      <div className="UpsellItem-infos">
        <div className="UpsellItem-title">
          <div className="UpsellItem-name">{upsell.title}</div>
          <div className="UpsellItem-price">{priceFormated}</div>
        </div>
        <div className="UpsellItem-description">{upsell.description}</div>
      </div>
    </div>
  );
};

export default UpsellItem;
